/**
 * iurop-related-products.js — "Te puede gustar" (PDP Laganini)
 *
 * Pide las recomendaciones del algoritmo de Shopify via Section Rendering
 * ({{ routes.product_recommendations_url }}?section_id=…&product_id=…) y
 * reinyecta el <ul data-rel-track> resultante. Si no hay recomendaciones y
 * la seccion ya trae fallback horneado (tienda sin catalogo), se deja tal cual.
 *
 * Tambien registra (una sola vez, guard global) las flechas de TODOS los
 * carruseles .laganini-rel ([data-rel-prev]/[data-rel-next]) — QA nº1:
 * el carrusel debe recorrerse entero en desktop.
 */
(function () {
  'use strict';

  // --- Flechas compartidas (guard: tambien las registra recently-viewed) ---
  // Este bloque esta DUPLICADO tal cual en assets/iurop-recently-viewed.js:
  // cada seccion carga su propio JS y puede colocarse sin la otra, asi que
  // ambas necesitan la implementacion completa. Gana la primera que corre y
  // publica window.laganiniRelCarousel para que la otra pida refrescos.
  if (!window.__laganiniRelArrows) {
    window.__laganiniRelArrows = true;

    // Tolerancia: scrollWidth/clientWidth/scrollLeft son fraccionarios y
    // rara vez cuadran exactos en los extremos.
    var EDGE = 2;

    var setArrowState = function (btn, off) {
      if (!btn) return;
      btn.disabled = off;
      btn.setAttribute('aria-disabled', off ? 'true' : 'false');
    };

    var updateSection = function (section) {
      if (!section) return;
      var track = section.querySelector('[data-rel-track]');
      if (!track) return;
      var arrows = section.querySelector('.laganini-rel__arrows');
      var max = track.scrollWidth - track.clientWidth;
      var scrollable = max > EDGE;
      if (arrows) arrows.classList.toggle('is-hidden', !scrollable);
      setArrowState(section.querySelector('[data-rel-prev]'), !scrollable || track.scrollLeft <= EDGE);
      setArrowState(section.querySelector('[data-rel-next]'), !scrollable || track.scrollLeft >= max - EDGE);
    };

    var updateAll = function () {
      var sections = document.querySelectorAll('[data-laganini-rel]');
      for (var i = 0; i < sections.length; i++) updateSection(sections[i]);
    };

    window.laganiniRelCarousel = { update: updateSection, updateAll: updateAll };

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var prev = e.target.closest('[data-rel-prev]');
      var next = e.target.closest('[data-rel-next]');
      if (!prev && !next) return;
      var section = (prev || next).closest('[data-laganini-rel]');
      if (!section) return;
      var track = section.querySelector('[data-rel-track]');
      if (!track || !track.children.length) return;
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      var step = track.children[0].getBoundingClientRect().width + gap;
      track.scrollBy({ left: prev ? -step : step, behavior: 'smooth' });
    });

    // scroll no burbujea: hay que escucharlo en fase de captura para que
    // valga tambien para las pistas que se inyectan despues.
    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (t && t.nodeType === 1 && t.hasAttribute && t.hasAttribute('data-rel-track')) {
        updateSection(t.closest('[data-laganini-rel]'));
      }
    }, { capture: true, passive: true });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      // setTimeout y no requestAnimationFrame: rAF no dispara con la pestana
      // en segundo plano.
      if (resizeTimer) window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(updateAll, 120);
    });

    document.addEventListener('shopify:section:load', updateAll);
    window.addEventListener('load', updateAll);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateAll);
    } else {
      updateAll();
    }
  }

  function refreshArrows() {
    if (window.laganiniRelCarousel) window.laganiniRelCarousel.updateAll();
  }

  function initRelated() {
    var roots = document.querySelectorAll('[data-related-root][data-related-url]');
    for (var i = 0; i < roots.length; i++) {
      (function (rootEl) {
        if (rootEl.getAttribute('data-related-loaded')) return;
        rootEl.setAttribute('data-related-loaded', 'true');
        fetch(rootEl.getAttribute('data-related-url'), { headers: { Accept: 'text/html' } })
          .then(function (res) { return res.ok ? res.text() : null; })
          .then(function (html) {
            if (!html) return;
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var nextTrack = parsed.querySelector('[data-rel-track]');
            var section = rootEl.closest('[data-laganini-rel]');
            if (!nextTrack || !nextTrack.children.length || !section) return;
            var track = rootEl.querySelector('[data-rel-track]');
            if (track) {
              track.innerHTML = nextTrack.innerHTML;
            } else {
              var header = rootEl.querySelector('.laganini-rel__header');
              if (header) header.insertAdjacentElement('afterend', nextTrack);
            }
            section.hidden = false;
            // El estado de las flechas depende del contenido: hay que
            // recalcularlo DESPUES de inyectar las cards.
            refreshArrows();
          })
          .catch(function () { /* fallback horneado o seccion oculta */ });
      })(roots[i]);
    }
  }

  document.addEventListener('shopify:section:load', initRelated);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRelated);
  } else {
    initRelated();
  }
})();
